import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 pt-16 md:pt-20 pb-8 px-4 md:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="relative bg-background-50 rounded-2xl p-8 md:p-12 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-brain-line text-xl text-primary-500"></i>
                </div>
                <span className="font-heading text-lg text-foreground-950">bbgpt.online</span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">
                bbgpt.online 专注人工智能教育的高品质在线学习平台。
                系统化课程体系 + 实战项目驱动 + 名师一对一指导，
                帮助每一位学员掌握AI核心技术。
              </p>
              <p className="text-xs text-foreground-400 mt-3">
                运营主体：一路有你（海南）实业有限公司
              </p>
              <p className="text-xs text-foreground-400">
                统一社会信用代码：91460100MABR8GD01J
              </p>
              <p className="text-xs text-foreground-400">
                联系邮箱：admin@bbgpt.online
              </p>
              <p className="text-xs text-foreground-400">
                联系电话：400-888-2499 ｜ +86 18824603638
              </p>
              <p className="text-xs text-foreground-400 mt-2">
                地址：海南省海口市美兰区新埠街道新埠岛新埠路9号海南自贸港跨境电商产业园主楼北侧三层东区301-22
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">课程体系</h4>
              <ul className="space-y-2.5">
                {footerLinks.courses.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                {footerLinks.company.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">法律信息</h4>
              <ul className="space-y-2.5">
                {footerLinks.legal.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="absolute -right-3 top-1/2 -translate-y-1/2 hidden lg:block">
            <div className="w-24 h-24 bg-primary-100/50 rounded-2xl rotate-12"></div>
          </div>
          <div className="absolute -left-2 bottom-8 hidden lg:block">
            <div className="w-16 h-16 bg-accent-100/60 rounded-xl -rotate-6"></div>
          </div>
        </div>

        <div className="border-t border-secondary-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span>&copy; 2026 一路有你（海南）实业有限公司 版权所有</span>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <span className="text-xs text-foreground-400">琼ICP备XXXXXXXX号</span>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <Link to="/terms" className="hover:text-primary-500 transition-colors cursor-pointer">
              服务条款
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/refund-policy" className="hover:text-primary-500 transition-colors cursor-pointer">
              退款政策
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}